import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MATERIAL,
  MODE,
  TEXTURE_QUALITY,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.MESHY_RETEXTURE_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.RETEXTURE,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
      },
      "prompt": {
        "type": "string",
        "minLength": 1,
        "maxLength": 800,
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.PBR,
      },
      "texture_quality": {
        "type": "string",
        // 8k requires meshy-6, meshy-7, or latest (model_version defaults to latest).
        "enum": [TEXTURE_QUALITY.TWO_K, TEXTURE_QUALITY.FOUR_K, TEXTURE_QUALITY.EIGHT_K],
        "default": TEXTURE_QUALITY.FOUR_K,
      },
    },
    "required": ["input_3d"],
    "allOf": [
      {
        "if": {
          "properties": { "prompt": { "const": "" } },
          "required": ["prompt"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "material": { "enum": [MATERIAL.BASIC, MATERIAL.PBR] } },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "enable_pbr": { "const": true },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "enable_pbr": { "const": false },
          },
        },
      },
    ],
  },
  "ui_schema": {},
}
